import React from 'react';
import {getLang, getTranslations} from '../../../../../translations';
import { AdditionalFees, AdditionalPrices } from '../../../../../types';
import {formatCurrency} from '../../../../../utils/format';
import PriceDetails from '../../PriceDetails';
import AdditionalOptionWrapper from './AdditionalOptionWrapper';

interface AdditionalDetailsInterface {
  fees: AdditionalPrices | undefined;
}

const AdditionalDetails = ({fees}: AdditionalDetailsInterface) => {
  const lang = getLang();
  const trans = getTranslations();
  const exclusions = [
    'sales_tax',
    'build_price',
    'federal_electric_incentive',
    'provincial_electric_incentive',
  ];

  return (
    <AdditionalOptionWrapper label={trans.details.summary.additional + ':'}>
      {fees &&
        Object.keys(fees).map((k, i) => {
          if (!exclusions.includes(k)) {
            const key = `additional-fee-${i}`;
            return (
              <PriceDetails
                key={key}
                name={
                  k === 'dealer_fee'
                    ? trans.labels.daf
                    : fees[k as AdditionalFees].label
                }
                disclaimer={k}
                price={formatCurrency(
                  Number(fees[k as AdditionalFees].value), true, lang
                )}
                bold={false}
              />
            );
          } else {
            return null;
          }
        })}
    </AdditionalOptionWrapper>
  );
};

export default AdditionalDetails;
